import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <div className="text-ink-soft font-display text-2xl animate-pulse" data-testid="protected-loading">Chargement…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (role && !(Array.isArray(role) ? role.includes(user.role) : user.role === role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
